


























import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Navigation from '../../modules/ui/_components/Navigation.vue';
import Toolbar from '../../modules/ui/_components/Toolbar.vue';

@Component({
  components: {
    Navigation,
    Toolbar,
  },
})
export default class UserLayout extends Vue {
  @Getter('version/current') private version!: string;
  @Getter('version/date') private date!: string;
  @Getter('version/expected') private expectedVersion!: string;

  @Action('auth/signOut') private storeSignOut!: () => Promise<void>;
  @Action('auth/loadUser') private loadUser!: any;
  @Action('version/read') private loadVersion!: any;

  private loading: boolean = false;

  private signOut(): void {
    this.storeSignOut().then(() => {
      this.$router.push({name: 'SignIn'});
    });
  }

  private async created() {
    this.loading = true;
    this.loadUser();
    await this.loadVersion();
    this.loading = false;
  }
}
